import { Component, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PDFExportComponent } from '@progress/kendo-angular-pdf-export';
import { Keys } from 'app/models/core/dropdowns';
import { ISearchLabs, ISearchLabsParameters } from 'app/models/searchLabs/searchLabs';
import { SettingsService } from 'app/services/core/settings.service';
import { SearchLabsService } from 'app/services/searchLabs/searchLabs.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LabApplicationMenuService } from 'app/services/application-menu/lab-application-menu.service';
import { InspectionService } from 'app/services/inspection/inspection.service';
import { drawDOM, exportPDF } from '@progress/kendo-drawing';
import { IInspectionActionsViewModel, IInspectionSummaryViewModel } from 'app/models/report/reports';
import { SharedService } from 'app/services/core/shared.service';

@Component({
  selector: 'inspectionSummaryReport',
  templateUrl: './inspectionSummaryReport.component.html',
  styleUrls: ['./inspectionSummaryReport.component.scss']
})
export class InspectionSummaryReportComponent {
  
  @ViewChild('pdf') pdf: PDFExportComponent;

  public inspectionData: IInspectionSummaryViewModel = {
    labName: '',
    orelapId: '',
    actions: [],
    assessmentType: '',
    assessmentDate: '',
    summary: '',
    inspectors: []
  };

  public correctiveActions: IInspectionActionsViewModel[][] = [];

  public groupedCorrectiveActions: {
    header: string, count: number, technologies:
      { tech: string, actions: IInspectionActionsViewModel[] }[]
  }[] = [];

  constructor(public searchLabsService: SearchLabsService,
    public settings: SettingsService,
    private dialogRef: MatDialogRef<InspectionSummaryReportComponent>,
    private labApplicationMenuService: LabApplicationMenuService,
    private inspectionService: InspectionService,
    private sharedService: SharedService
  ) {
    this.inspectionService.getInspectionSummary(this.sharedService.currentApplication.labApplicationId, this.sharedService.currentLabId).subscribe(
      response => {
        this.inspectionData = response;
        this.correctiveActions = response.actions;
        this.groupTechnologies(response.actions);
      },
      error => console.log('error', error)
    );
  }

  groupTechnologies(actions: IInspectionActionsViewModel[][]): void {
    // actions is a 2D array where each inner array has items with the same header
    this.groupedCorrectiveActions = actions.map(actionGroup => {
      if (actionGroup.length === 0) {
        return { header: '', count: 0, technologies: [] };
      }

      // Get the header from the first item (all items in group have same header)
      const header = actionGroup[0].header;
      const count = actionGroup.length;

      // Group by technology within this header group
      const byTechnology: { [key: string]: IInspectionActionsViewModel[] } = {};

      actionGroup.forEach(action => {
        if (!byTechnology[action.technology]) {
          byTechnology[action.technology] = [];
        }
        byTechnology[action.technology].push(action);
      });

      return {
        header: header,
        count: count,
        technologies: Object.keys(byTechnology).map(tech => ({
          tech: tech,
          actions: byTechnology[tech]
        }))
      };
    });
  }

  ngOnInit(): void {
  }

  printReport(): void {
    if (this.pdf) {
      this.pdf.saveAs('ORELAP_Inspection_Summary_Report.pdf');
      
      // Also save to database
      // this.savePdfToDatabase();
    }
  }

  // savePdfToDatabase(): void {
  //   const element = document.querySelector('.report-content');
  //   if (!element) {
  //     console.error('PDF content element not found');
  //     return;
  //   }

  //   drawDOM(element as HTMLElement, {
  //     paperSize: 'auto',
  //     margin: { top: '1cm', right: '1cm', bottom: '1cm', left: '1cm' }
  //   }).then((group) => {
  //     return exportPDF(group);
  //   }).then((dataUri) => {
  //     // Convert data URI to Blob
  //     const byteString = atob(dataUri.split(',')[1]);
  //     const mimeString = dataUri.split(',')[0].split(':')[1].split(';')[0];
  //     const ab = new ArrayBuffer(byteString.length);
  //     const ia = new Uint8Array(ab);
  //     for (let i = 0; i < byteString.length; i++) {
  //       ia[i] = byteString.charCodeAt(i);
  //     }
  //     const blob = new Blob([ab], { type: mimeString });
      
  //     // Save to database
  //     const fileName = `ORELAP_Inspection_Summary_${this.inspectionData.orelapId}_${new Date().getTime()}.pdf`;
  //     this.inspectionService.saveInspectionSummaryPdf(
  //       this.sharedService.currentApplication.labApplicationId,
  //       this.sharedService.currentLabId,
  //       blob,
  //       fileName
  //     ).subscribe(
  //       response => {
  //         console.log('PDF saved to database successfully', response);
  //       },
  //       error => {
  //         console.error('Error saving PDF to database', error);
  //       }
  //     );
  //   }).catch((error) => {
  //     console.error('Error generating PDF', error);
  //   });
  // }


  closeDialog(): void {
    this.dialogRef.close();
  }

}

